module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/bang.png?73efe05fadb464184b8c27a1fdefa987";